import React, { useState, useEffect } from 'react';
import { getLicenseRules } from '../services/assujettiService';

interface Rule {
  id: string;
  activity: string;
  category: string;
  duration_months: number;
  amount: number;
  currency: string;
}

export default function V4SettingsPage() {
  const [rules, setRules] = useState<Rule[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getLicenseRules()
      .then((r: any) => setRules(Array.isArray(r) ? r : r.data ?? r.rules ?? []))
      .catch((e: any) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Parametres</h1>
      <p className="text-gray-500 text-sm mb-6">Regles administratives des licences (lecture seule).</p>

      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6 text-sm text-yellow-800">
        Les durees et montants des categories sont charges depuis des regles administratives parametrables. Ils ne doivent pas etre codes en dur dans l'application.
      </div>

      {loading ? (
        <div className="bg-white rounded-lg shadow p-8 text-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto" /><p className="mt-4 text-gray-500">Chargement...</p></div>
      ) : error ? (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">{error}</div>
      ) : rules.length === 0 ? (
        <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">Aucune regle configuree.</div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {['Activite', 'Categorie', 'Duree', 'Montant'].map(h => (
                  <th key={h} className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {rules.map((r, i) => (
                <tr key={r.id || i} className="hover:bg-gray-50">
                  <td className="px-5 py-4 text-sm">{r.activity}</td>
                  <td className="px-5 py-4 text-sm font-medium">{r.category}</td>
                  <td className="px-5 py-4 text-sm">{r.duration_months} mois</td>
                  <td className="px-5 py-4 text-sm">{r.amount?.toLocaleString()} {r.currency || 'USD'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
